import { useCallback } from 'react';
import {
  useGetKeyValueSettings,
  useKeyValueSettingsMutation,
  updateCache
} from '~/modules/common/hooks';
import { useMeContext } from '~/modules/me';

export const TARGET_UTILIZATION_SETTINGS_KEY = 'target_utilization_settings';

export const DEFAULT_TARGET_UTILIZATION = 100;

export const useTargetUtilizationSettings = () => {
  const {
    featureFlags: { isPsaRmpBenchOverallocationEnabled }
  } = useMeContext();

  const { isLoading, keyValueSettings } = useGetKeyValueSettings(
    TARGET_UTILIZATION_SETTINGS_KEY,
    !isPsaRmpBenchOverallocationEnabled
  );

  return {
    isLoading,
    targetUtilization:
      keyValueSettings?.targetUtilization ?? DEFAULT_TARGET_UTILIZATION
  };
};

export const usePutTargetUtilizationSettings = () => {
  const {
    featureFlags: { isPsaRmpBenchOverallocationEnabled }
  } = useMeContext();

  const [putKeyValueSettings] = useKeyValueSettingsMutation(
    updateCache(TARGET_UTILIZATION_SETTINGS_KEY)
  );

  const putTargetUtilizationSettings = useCallback(
    ({ targetUtilization }) => {
      putKeyValueSettings({
        variables: {
          input: {
            key: TARGET_UTILIZATION_SETTINGS_KEY,
            settings: { targetUtilization }
          }
        }
      });
    },
    [putKeyValueSettings]
  );

  return {
    putTargetUtilizationSettings: isPsaRmpBenchOverallocationEnabled
      ? putTargetUtilizationSettings
      : null
  };
};
